import React from 'react';
import { Award, GraduationCap, Heart } from 'lucide-react';
export function PhysicianProfileHodor() {
  return <div className="min-h-screen bg-gradient-to-b from-white to-[#f8faff] dark:from-[#0a0e17] dark:to-[#111827]" data-id="element-732">
      {/* Hero Section */}
      <section className="pt-32 pb-16 px-6" data-id="element-733">
        <div className="container mx-auto max-w-6xl" data-id="element-734">
          <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-735">
            {/* Image */}
            <div className="flex justify-center" data-id="element-736">
              <div className="relative" data-id="element-737">
                <div className="absolute inset-0 bg-gradient-to-r from-[#BBDDFF] to-[#C85A15] rounded-2xl blur-2xl opacity-20" data-id="element-738"></div>
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/jtoD2woMih8P3b3oRePJt3/Dr._Hodor_Image.jpg" alt="Dr. Jonathan Hodor" className="relative rounded-2xl shadow-2xl w-full max-w-md" data-id="element-739" />
              </div>
            </div>

            {/* Info */}
            <div data-id="element-740">
              <h1 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-741">
                <span className="bg-gradient-to-r from-[#BBDDFF] to-[#C85A15] bg-clip-text text-transparent" data-id="element-742">
                  Dr. Jonathan Hodor, DO, MS, ACOOG
                </span>
              </h1>
              <p className="text-xl text-gray-600 dark:text-gray-300 mb-6" data-id="element-743">
                Board Certified Maternal-Fetal Medicine Specialist & Healthcare
                Executive
              </p>
              <div className="flex items-center gap-2 text-gray-600 dark:text-gray-400 mb-8" data-id="element-744">
                <Heart className="text-[#C85A15]" size={20} data-id="element-745" />
                <span data-id="element-746">
                  31+ years of clinical excellence and innovative care delivery
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Bio Section */}
      <section className="py-16 px-6" data-id="element-747">
        <div className="container mx-auto max-w-4xl" data-id="element-748">
          <div className="bg-white dark:bg-gray-800/80 backdrop-blur-sm rounded-2xl p-10 shadow-xl border border-white/20 dark:border-gray-700/30" data-id="element-749">
            <div className="flex items-center gap-3 mb-6" data-id="element-750">
              <div className="w-12 h-12 rounded-full bg-[#C85A15]/20 flex items-center justify-center" data-id="element-751">
                <Heart className="text-[#C85A15]" size={24} data-id="element-752" />
              </div>
              <h2 className="text-3xl font-bold" data-id="element-753">About Dr. Hodor</h2>
            </div>
            <div className="space-y-4 text-gray-600 dark:text-gray-300 text-lg leading-relaxed" data-id="element-754">
              <p data-id="element-755">
                Dr. Jonathan Hodor is a board-certified Maternal-Fetal Medicine
                specialist and healthcare executive with over 31 years of
                clinical experience. He serves as Medical Director at Richmond
                MFM and leads RNR Aesthetics / Potomac Performance and RNR
                Regenerative Therapeutics, where he provides evidence-based
                wellness treatments including hormone optimization, peptide
                therapy, medical weight loss, IV therapy, and advanced wound
                care management.
              </p>
              <p data-id="element-756">
                Previously serving as Assistant Medical Director at Maryland
                Perinatal Associates, Dr. Hodor and his business partner oversaw
                8 physicians across 8 offices, supported 200+ daily patient
                visits, and led system-wide quality initiatives. Licensed in 23
                states, Dr. Hodor brings exceptional reach and a proven track
                record in clinical leadership and innovative care delivery.
              </p>
            </div>
          </div>

          {/* Certifications Section */}
          <div className="bg-white dark:bg-gray-800/80 backdrop-blur-sm rounded-2xl p-10 shadow-xl border border-white/20 dark:border-gray-700/30 mt-8" data-id="element-757">
            <div className="flex items-center gap-3 mb-8" data-id="element-758">
              <div className="w-12 h-12 rounded-full bg-[#BBDDFF]/20 flex items-center justify-center" data-id="element-759">
                <Award className="text-[#BBDDFF]" size={24} data-id="element-760" />
              </div>
              <h2 className="text-3xl font-bold" data-id="element-761">Board Certifications</h2>
            </div>
            <div className="grid md:grid-cols-2 gap-6" data-id="element-762">
              <div className="flex items-start gap-3" data-id="element-763">
                <Award className="text-[#C85A15] flex-shrink-0 mt-1" size={20} data-id="element-764" />
                <div data-id="element-765">
                  <h3 className="font-semibold mb-1" data-id="element-766">
                    ACOOG Maternal-Fetal Medicine
                  </h3>
                  <p className="text-gray-600 dark:text-gray-300" data-id="element-767">
                    American College of Osteopathic Obstetrics & Gynecology
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-3" data-id="element-768">
                <Award className="text-[#C85A15] flex-shrink-0 mt-1" size={20} data-id="element-769" />
                <div data-id="element-770">
                  <h3 className="font-semibold mb-1" data-id="element-771">
                    ACOOG Obstetrics & Gynecology
                  </h3>
                  <p className="text-gray-600 dark:text-gray-300" data-id="element-772">
                    American College of Osteopathic Obstetrics & Gynecology
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Professional Affiliations */}
          <div className="bg-white dark:bg-gray-800/80 backdrop-blur-sm rounded-2xl p-10 shadow-xl border border-white/20 dark:border-gray-700/30 mt-8" data-id="element-773">
            <div className="flex items-center gap-3 mb-8" data-id="element-774">
              <div className="w-12 h-12 rounded-full bg-[#BBDDFF]/20 flex items-center justify-center" data-id="element-775">
                <GraduationCap className="text-[#BBDDFF]" size={24} data-id="element-776" />
              </div>
              <h2 className="text-3xl font-bold" data-id="element-777">Professional Affiliations</h2>
            </div>
            <div className="space-y-4" data-id="element-778">
              <div className="flex items-center gap-3" data-id="element-779">
                <div className="w-2 h-2 rounded-full bg-[#C85A15]" data-id="element-780"></div>
                <p className="text-gray-600 dark:text-gray-300" data-id="element-781">
                  <span className="font-semibold" data-id="element-782">SMFM</span> – Society for
                  Maternal-Fetal Medicine
                </p>
              </div>
              <div className="flex items-center gap-3" data-id="element-783">
                <div className="w-2 h-2 rounded-full bg-[#C85A15]" data-id="element-784"></div>
                <p className="text-gray-600 dark:text-gray-300" data-id="element-785">
                  <span className="font-semibold" data-id="element-786">AIUM</span> – American
                  Institute of Ultrasound in Medicine
                </p>
              </div>
              <div className="flex items-center gap-3" data-id="element-787">
                <div className="w-2 h-2 rounded-full bg-[#C85A15]" data-id="element-788"></div>
                <p className="text-gray-600 dark:text-gray-300" data-id="element-789">
                  <span className="font-semibold" data-id="element-790">ACOOG</span> – American
                  College of Osteopathic Obstetrics & Gynecology
                </p>
              </div>
              <div className="flex items-center gap-3" data-id="element-791">
                <div className="w-2 h-2 rounded-full bg-[#C85A15]" data-id="element-792"></div>
                <p className="text-gray-600 dark:text-gray-300" data-id="element-793">
                  <span className="font-semibold" data-id="element-794">ACOG</span> – American College
                  of Obstetrics & Gynecology
                </p>
              </div>
              <div className="flex items-center gap-3" data-id="element-795">
                <div className="w-2 h-2 rounded-full bg-[#C85A15]" data-id="element-796"></div>
                <p className="text-gray-600 dark:text-gray-300" data-id="element-797">
                  <span className="font-semibold" data-id="element-798">AOA</span> – American
                  Osteopathic Association
                </p>
              </div>
            </div>
          </div>

          {/* Licensed States */}
          <div className="bg-white dark:bg-gray-800/80 backdrop-blur-sm rounded-2xl p-10 shadow-xl border border-white/20 dark:border-gray-700/30 mt-8" data-id="element-799">
            <div className="flex items-center gap-3 mb-8" data-id="element-800">
              <div className="w-12 h-12 rounded-full bg-[#C85A15]/20 flex items-center justify-center" data-id="element-801">
                <Award className="text-[#C85A15]" size={24} data-id="element-802" />
              </div>
              <h2 className="text-3xl font-bold" data-id="element-803">Licensed in 23 States</h2>
            </div>
            <div className="flex flex-wrap gap-3" data-id="element-804">
              {['NJ', 'MD', 'VA', 'WV', 'PA', 'TX', 'AZ', 'DE', 'MO', 'FL', 'GA', 'ME', 'AL', 'CO', 'MN', 'TN', 'NY', 'KY', 'CA', 'MI', 'HI', 'MS', 'CT'].map(state => <span key={state} className="bg-gradient-to-r from-[#BBDDFF]/20 to-[#C85A15]/20 px-4 py-2 rounded-full font-semibold" data-id="element-805">
                  {state}
                </span>)}
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 px-6" data-id="element-806">
        <div className="container mx-auto max-w-4xl text-center" data-id="element-807">
          <div className="bg-gradient-to-r from-[#BBDDFF]/10 to-[#C85A15]/10 rounded-2xl p-12 border border-white/20 dark:border-gray-700/30" data-id="element-808">
            <h2 className="text-3xl font-bold mb-4" data-id="element-809">
              Ready to Start Your Journey?
            </h2>
            <p className="text-lg text-gray-600 dark:text-gray-300 mb-8" data-id="element-810">
              Dr. Hodor is here to support you with personalized care tailored
              to your needs.
            </p>
            <a href="https://staging.joinomu.com/patient/onboarding" target="_blank" rel="noopener noreferrer" className="inline-flex items-center bg-gradient-to-r from-[#C85A15] to-[#FF8A3D] text-white font-medium py-3 px-8 rounded-full hover:shadow-lg transition-all" data-id="element-811">
              Get Started Today
            </a>
          </div>
        </div>
      </section>
    </div>;
}